import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MatStep, MatStepper} from '@angular/material/stepper';
import { Data, AppService } from '../../../app.service';
import {UsersService} from "../../../admin/users/users.service";
import {Store} from "../../../admin/users/user.model";
import {Order, OrderItem} from "../../../app.models";
@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {
  billingForm: FormGroup;
  public orders = [
    { number: '#3258', date: 'March 29, 2018', status: 'Completed', total: '$140.00 for 2 items', invoice: true },
    { number: '#3145', date: 'February 14, 2018', status: 'On hold', total: '$255.99 for 1 item', invoice: false },
    { number: '#2972', date: 'January 7, 2018', status: 'Processing', total: '$255.99 for 1 item', invoice: true },
    { number: '#2971', date: 'January 5, 2018', status: 'Completed', total: '$73.00 for 1 item', invoice: true },
    { number: '#1981', date: 'December 24, 2017', status: 'Pending Payment', total: '$285.00 for 2 items', invoice: false },
    { number: '#1781', date: 'September 3, 2017', status: 'Refunded', total: '$49.00 for 2 items', invoice: false }
  ]
  constructor(public appService:AppService, public formBuilder: FormBuilder, private userService: UsersService) { }


  ngOnInit() {

    this.billingForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleName: '',
      company: '',
      email: ['', Validators.required],
      mainPhone: ['', Validators.required],
      country: ['', ],
      city: ['', ],
      state: '',
      zip: ['', ],
      address: ['', ]
    });

    this.loadData();
  }
  public loadData():void {
    this.userService.getUser().subscribe((res:any)=>{

      this.billingForm.controls['firstName'].setValue(res.user.firstName || '')
      this.billingForm.controls['lastName'].setValue(res.user.lastName || '')
      this.billingForm.controls['email'].setValue(res.user.email || '')
      this.billingForm.controls['mainPhone'].setValue(res.user.mainPhone || '')
    })
  }
  public buildOrder(): Order{
    const cartList = this.appService.Data.cartList;
    const totalPrice = this.appService.Data.totalPrice;
    const totalCartCount = this.appService.Data.totalCartCount;
    const userDetails = this.billingForm.controls
    const itemList = this.appService.Data.cartList.map(res=>{
      return {
        product: res,
        quantity: res.cartCount,
        freeText: null
      }
    })
    return {
      number:null,
      submittedDate: null,
      user: null,
      paymentMethod: null,
      totalPrice: totalPrice,
      status: null,
      paymentStatus: "",
      orderItem: itemList,
      firstName: userDetails['firstName'].value,
      lastName: userDetails['lastName'].value,
      email: userDetails['email'].value,
      phone: userDetails['mainPhone'].value,
      deliveryOption1: null,
      deliveryOption2: null,
      deliveryOption3: null,
    };
  }
}
